import { Directive, OnDestroy } from '@angular/core';
import { Subject } from "rxjs";

@Directive()
export class DestroyableComponent implements OnDestroy {
	private readonly onDestroySubject = new Subject();
	public readonly onDestroy$ = this.onDestroySubject.asObservable();
	
	addOnDestroy(fn: () => void) {
		return this.onDestroy$.subscribe(() => fn());
	}
	
	ngOnDestroy() {
		this.onDestroySubject.next();
	}
}